import { Typography } from '@mui/material';
import MemoryIcon from '@mui/icons-material/Memory';
import { router } from '../../router';

export const MobileBranding = () => {
  return (
    <>
      <MemoryIcon
        sx={{ display: { xs: 'flex', md: 'none' }, mr: 1, fontSize: 26 }}
      />
      <Typography
        variant="h6"
        noWrap
        component="a"
        onClick={() => router.navigate('/')}
        sx={{
          mr: 1,
          display: { xs: 'flex', md: 'none' },
          flexGrow: 1,
          fontFamily: 'inherit',
          cursor: 'pointer',
          fontWeight: 700,
          letterSpacing: '0.04em',
          color: 'inherit',
          textDecoration: 'none'
        }}
      >
        Algo Trader
      </Typography>
    </>
  );
};
